import { TEMPLATE_TYPES } from "features/templates/constants";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  OverlayDialogContent,
  OverlayDialogTitle,
} from "common/components/ui/Dialog";

import EditButton from "./EditButton";
import { useFlowTemplateContext } from "./FlowTemplateContext";

import type { JSX } from "react";

interface MobileLayoutProps {
  actionDelayComponent: JSX.Element;
  templatePreviewComponent: JSX.Element;
  templateEditorComponent: JSX.Element;
  removeButtonComponent: JSX.Element;
  templateSelectComponent: JSX.Element;
}

export default function MobileLayout({
  actionDelayComponent,
  templatePreviewComponent,
  templateEditorComponent,
  removeButtonComponent,
  templateSelectComponent,
}: MobileLayoutProps) {
  const { isEditing, handleSave, handleDiscard, flowTemplate } =
    useFlowTemplateContext();

  return (
    <>
      <div className="flex flex-col gap-2">
        {actionDelayComponent}
        <div className="flex items-center gap-2">
          {templateSelectComponent}
          <EditButton />
        </div>
        {templatePreviewComponent}
        {removeButtonComponent}
      </div>

      <Dialog open={isEditing} onAfterClose={handleDiscard}>
        <OverlayDialogContent>
          <OverlayDialogTitle>
            Edit {TEMPLATE_TYPES[flowTemplate.type].label.toLowerCase()}
          </OverlayDialogTitle>
          <div className="flex flex-col px-4 py-6 flex-1">
            {templateEditorComponent}
          </div>
          <div className="p-4 flex justify-between">
            <DialogClose asChild>
              <Button variant="outline-black" onClick={handleDiscard}>
                Discard
              </Button>
            </DialogClose>
            <Button onClick={handleSave}>Save</Button>
          </div>
        </OverlayDialogContent>
      </Dialog>
    </>
  );
}
